import { render } from "./BotList.vue?vue&type=template&id=1a0dbbc6&scoped=true"
import script from "./BotList.vue?vue&type=script&lang=js"
export * from "./BotList.vue?vue&type=script&lang=js"

import "./BotList.vue?vue&type=style&index=0&id=1a0dbbc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0dbbc6"]])

export default __exports__